class KartFeatures {
  constructor() {
    this.initFeatures();
  }

  initFeatures() {
    const seeMoreBtns = document.querySelectorAll('.see-more-btn');
    
    seeMoreBtns.forEach(btn => {
      const featureId = btn.getAttribute('data-feature-id');
      const pointsList = document.getElementById(`featurePoints-${featureId}`);
      
      if (!pointsList) return;
      
      btn.setAttribute('data-expanded', 'false');
      
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.togglePoints(btn, pointsList);
      });
    });
  }

  togglePoints(button, pointsList) {
    const isExpanded = button.getAttribute('data-expanded') === 'true';
    const hiddenPoints = pointsList.querySelectorAll('.hidden-point');
    
    if (!isExpanded) {
      hiddenPoints.forEach((point, index) => {
        setTimeout(() => {
          point.classList.add('visible');
        }, index * 50);
      });
      
      button.setAttribute('data-expanded', 'true');
      button.classList.add('expanded');
      button.querySelector('.btn-text').textContent = 'See Less';
      
    } else {
      hiddenPoints.forEach(point => {
        point.classList.remove('visible');
      });
      
      button.setAttribute('data-expanded', 'false');
      button.classList.remove('expanded');
      button.querySelector('.btn-text').textContent = 'See More';
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new KartFeatures();
});

document.addEventListener('shopify:section:load', () => {
  new KartFeatures();
});